export enum SyncEvent {
    Destroyed = "destroyed"
}
